








































































































import {
  defineComponent,
  computed,
  useContext,
  onMounted,
  useMeta,
} from '@nuxtjs/composition-api'
import { useBreadcrumb } from '~/composables/ui/useBreadcrumb'
import { useLoading } from '~/composables/ui/useLoading'
import { CartEvents, useCart } from '~/composables/useCart'
import { usePromotion } from '~/composables/usePromotion'
import { useAuth } from '~/composables/useAuth'
import { useEvents } from '~/composables/framework/useEvents'
import { useBreadcrumbsSchemaScript } from '~/composables/useSchemaScript'
import { useProductSelections } from '~/composables/product/useProductSelection'
import { MAX_QUANTITY } from '~/composables/product/useProduct'
import { CartLineAction } from '~/types/cart'

export default defineComponent({
  name: 'PagesCart',

  setup() {
    const { i18n } = useContext()
    const { breadcrumbs, setBreadcrumbs } = useBreadcrumb()
    const { wishSelections, productSelections } = useProductSelections()
    const { breadcrumbsSchemaScript, setBreadcrumbsSchemaScript } =
      useBreadcrumbsSchemaScript()
    const {
      cart,
      cartLines,
      ensureCart,
      addToCart,
      totalQuantity,
      productQuantity,
      loading: cartLoading,
    } = useCart()
    const { getVouchers } = usePromotion()
    const { authed } = useAuth()
    const { emit } = useEvents()

    const wishlistQuality = computed(() =>
      wishSelections.value ? wishSelections.value.length : 0
    )
    const isEmpty = computed(() => !cartLines.value.length)

    setBreadcrumbs([
      {
        label: i18n.t('checkout.shoppingBag') as string,
      },
    ])
    setBreadcrumbsSchemaScript(breadcrumbs.value!)

    const initLoading = useLoading(true)
    const init = () => {
      return initLoading.scope(async () => {
        await ensureCart()

        emit(CartEvents.View, {
          cart: cart.value,
        })

        if (authed.value) {
          await getVouchers()
        }
      })
    }
    onMounted(() => {
      init()
    })

    useMeta(() => {
      return breadcrumbsSchemaScript.value
        ? {
            script: [breadcrumbsSchemaScript.value],
          }
        : {}
    })

    const unableAddWishListToCart = computed(
      () =>
        !!productSelections.value?.find(
          (item) =>
            item.product &&
            !(
              item.product.isOrderable &&
              (item.product.maxStockEnabled
                ? item.product.stockQuantity
                : MAX_QUANTITY) -
                productQuantity(item.product.id) >
                0
            )
        )
    )

    const addWishListToCart = () => {
      const addCartData = productSelections.value
        ?.filter((item) => item.product?.id)
        .map((item2) => ({
          action: CartLineAction.Add,
          productId: item2.product.id,
          quantity: 1,
        }))
      addToCart(addCartData, 1)
    }

    return {
      initLoading: initLoading.value,
      isEmpty,
      totalQuantity,
      addWishListToCart,
      unableAddWishListToCart,
      wishlistQuality,
      cartLoading,
    }
  },

  head: {},
})
